import { path } from "@/routes/path";
import type { ISidebarItems } from "@/components/organisms/sidebar";
import type { IRole } from "@/interfaces";
import type { IFooterSidebarItem } from "@/components/organisms/sidebar/types";

export const sidebarItems: { [key in IRole]: ISidebarItems[] } = {
  "super-admin": [
    {
      iconName: "Home",
      name: "dashboard",
      items: { path: "/" },
    },
    {
      iconName: "Hospital",
      name: "hfAndMedicalCenterManagement",
      items: {
        child: [
          { name: "hf", path: path.hf.hfList.link() },
          {
            name: "medicalCenter",
            path: path.msp.medicalCenterManagement.link(),
          },
        ],
      },
    },
    {
      iconName: "UsersGroupRounded",
      name: "userManagement.title",
      items: {
        child: [
          {
            name: "userManagement.users",
            path: path.users.users.link(),
          },
          {
            name: "userManagement.admins",
            path: path.users.admin.link(),
          },
          {
            name: "userManagement.localAdmins",
            path: path.users.localAdmin.link(),
          },
          {
            name: "userManagement.doctors",
            path: path.users.doctor.link(),
          },
          {
            name: "userManagement.staffs",
            path: path.users.staff.link(),
          },
          {
            name: "userManagement.patients",
            path: path.users.patient.link(),
          },
        ],
      },
    },
    {
      iconName: "CheckSquare",
      name: "assignToDoctor",
      items: {
        child: [
          {
            name: "assignStaffToDoctor",
            path: path.assignStaffToDoctor.assignStaffToDoctor.link(),
          },
          {
            name: "assignMspToDoctor",
            path: path.msp.assignMspList.link(),
          },
        ],
      },
    },
    {
      iconName: "DollarMinimalistic",
      name: "financialManagement.title",
      items: {
        child: [
          {
            name: "financialManagement.accountingReport",
            path: path.financialReports.financialReports.link(),
          },
          {
            name: "financialManagement.ruleDefinition",
            path: path.financial.list.link(),
          },
          /* {
            name: "financialManagement.paymentMethod",
            path: "EMPTY",
          },*/
          {
            name: "financialManagement.patientWallet",
            path: path.financial.wallet.link(),
          },
          /* {
            name: "financialManagement.createAds",
            path: "EMPTY",
          },*/
        ],
      },
    },
    {
      iconName: "Rate",
      name: "comments",
      items: {
        path: path.comments.comments.link(),
      },
    },
    {
      iconName: "MonitorCamera",
      name: "AppointmentManagement.title",
      items: {
        child: [
          {
            name: "AppointmentManagement.appointmentTimesList",
            path: path.appointment.list.link("all"),
          },
          {
            name: "AppointmentManagement.pastVisitSummaryNotes",
            path: path.summaryNote.list.link(),
          },
        ],
      },
    },
    {
      iconName: "MonitorCamera",
      name: "reportGeneration.title",
      items: {
        child: [
          {
            name: "userManagement.patients",
            path: path.reports.patients.link(),
          },
          {
            name: "AppointmentManagement.title",
            path: path.reports.appointments.link(),
          },
          {
            name: "doctorFinancialManagements",
            path: path.reports.doctorFinancial.link(),
          },
          {
            name: "hfFinancialManagements",
            path: path.reports.hfFinancial.link(),
          },
          {
            name: "pastVisitSummaryNote",
            path: path.reports.visitSummaryNotes.link(),
          },
        ],
      },
    },
  ],
  "local-admin": [
    {
      iconName: "Home",
      name: "dashboard",
      items: { path: "/" },
    },
    {
      iconName: "UsersGroupRounded",
      name: "userManagement.title",
      items: {
        child: [
          {
            name: "userManagement.staffs",
            path: path.users.staff.link(),
          },
          {
            name: "userManagement.patients",
            path: path.users.patient.link(),
          },
          {
            name: "userManagement.doctors",
            path: path.users.doctor.link(),
          },
        ],
      },
    },
    {
      iconName: "CheckSquare",
      name: "assignStaffToDoctor",
      items: {
        path: path.assignStaffToDoctor.assignStaffToDoctor.link(),
      },
    },
    {
      iconName: "WalletMoney",
      name: "financialManagement.title",
      items: {
        child: [
          {
            name: "financialManagement.accountingReport",
            path: path.financialReports.financialReports.link(),
          },
          {
            name: "financialManagement.ruleDefinition",
            path: path.financial.list.link(),
          },
          {
            name: "financialManagement.patientWallet",
            path: path.financial.wallet.link(),
          },
        ],
      },
    },
    {
      iconName: "MonitorCamera",
      name: "AppointmentManagement.title",
      items: {
        child: [
          {
            name: "AppointmentManagement.onlineVisit",
            path: path.appointment.list.link("online-visit"),
          },
          {
            name: "AppointmentManagement.inPersonVisit",
            path: path.appointment.list.link("in-person-visit"),
          },
        ],
      },
    },
    {
      iconName: "Rate",
      name: "comments",
      items: {
        path: path.comments.comments.link(),
      },
    },
    {
      iconName: "MonitorCamera",
      name: "reportGeneration.title",
      items: {
        child: [
          {
            name: "userManagement.patients",
            path: path.reports.patients.link(),
          },
          {
            name: "AppointmentManagement.title",
            path: path.reports.appointments.link(),
          },
          {
            name: "doctorFinancialManagements",
            path: path.reports.doctorFinancial.link(),
          },
          {
            name: "hfFinancialManagements",
            path: path.reports.hfFinancial.link(),
          },
          {
            name: "pastVisitSummaryNote",
            path: path.reports.visitSummaryNotes.link(),
          },
        ],
      },
    },
  ],
  doctor: [
    {
      iconName: "Home",
      name: "dashboard",
      items: { path: "/" },
    },
    {
      iconName: "CalendarAdd",
      name: "availabilityTime",
      items: {
        path: path.availabilityTime.availabilityTime.link(),
      },
    },
    {
      iconName: "MonitorCamera",
      name: "AppointmentManagement.myAppointments",
      items: {
        child: [
          {
            name: "AppointmentManagement.onlineVisit",
            path: path.appointment.list.link("online-visit"),
          },
          {
            name: "AppointmentManagement.inPersonVisit",
            path: path.appointment.list.link("in-person-visit"),
          },
        ],
      },
    },
    {
      iconName: "UsersGroupTwoRounded",
      name: "myPatients",
      items: {
        child: [
          { name: "patientList", path: path.myPatients.patientsList.link() },
          { name: "pastVisitSummaryNote", path: path.summaryNote.list.link() },
          {
            name: "pastVisitSummaryNoteManagement",
            path: path.summaryNote.management.link(),
          },
        ],
      },
    },
    {
      iconName: "UsersGroupTwoRounded",
      name: "myStaffAndMsp",
      items: {
        path: path.doctorStaff.list.link(),
      },
    },
    {
      name: "myPatterns",
      iconName: "JarOfPills",
      items: {
        child: [
          { name: "medicinePatterns", path: path.patterns.list.link("drug") },
          { name: "experimentPatterns", path: path.patterns.list.link("lab") },
          { name: "imagingPatterns", path: path.patterns.list.link("imaging") },
        ],
      },
    },
    {
      iconName: "WalletMoney",
      name: "financialManagements",
      items: {
        child: [
          {
            name: "financialRecords",
            path: path.financialRecords.doctorFinancialRecords.link(),
          },
        ],
      },
    },
    {
      iconName: "MonitorCamera",
      name: "reportGeneration.title",
      items: {
        child: [
          {
            name: "userManagement.patients",
            path: path.reports.doctorPatientsPath.link(),
          },
          {
            name: "AppointmentManagement.title",
            path: path.reports.appointments.link(),
          },
          {
            name: "doctorFinancialManagements",
            path: path.reports.doctorFinancialForDoctorPath.link(),
          },
          {
            name: "pastVisitSummaryNote",
            path: path.reports.visitSummaryNotes.link(),
          },
        ],
      },
    },
  ],
  patient: [
    {
      iconName: "Home",
      name: "dashboard",
      items: { path: "/" },
    },
    {
      iconName: "PaperAdd",
      name: "inputFormManagement",
      items: {
        path: path.intakeForm.list.link(),
      },
    },
    {
      iconName: "MonitorCamera",
      name: "AppointmentManagement.myAppointments",
      items: {
        child: [
          {
            name: "AppointmentManagement.onlineVisit",
            path: path.appointment.list.link("online-visit"),
          },
          {
            name: "AppointmentManagement.inPersonVisit",
            path: path.appointment.list.link("in-person-visit"),
          },
        ],
      },
    },
    {
      iconName: "PaperMedicine",
      name: "healthRecord",
      items: {
        child: [
          { name: "pastVisitSummaryNote", path: path.summaryNote.list.link() },
          { name: "storedResults", path: path.storedResult.patientList.link() },
          {
            name: "pastMedicalHistory",
            path: path.pastMedicalHistory.list.link(),
          },
        ],
      },
    },
    {
      iconName: "WalletMoney",
      name: "financialManagements",
      items: {
        child: [
          {
            name: "financialRecords",
            path: path.financialRecords.financialRecords.link(),
          },
          {
            name: "walletBalance",
            path: path.financialRecords.walletBalance.link(),
          },
        ],
      },
    },
    {
      iconName: "UsersGroupTwoRounded",
      name: "myFamily",
      items: {
        path: path.myFamily.myFamily.link(),
      },
    },
    {
      iconName: "ClipboardHeart",
      name: "MedicalOrders.title",
      items: {
        child: [
          {
            name: "MedicalOrders.prescription",
            path: path.healthRecord.prescription.link(),
          },
          {
            name: "MedicalOrders.referrals",
            path: path.healthRecord.referral.link(),
          },
          {
            name: "MedicalOrders.followup",
            path: path.healthRecord.followup.link(),
          },
          {
            name: "MedicalOrders.orders",
            path: path.healthRecord.orders.link(),
          },
          {
            name: "MedicalOrders.experiments",
            path: path.healthRecord.experiments.link(),
          },
          {
            name: "MedicalOrders.imaging",
            path: path.healthRecord.images.link(),
          },
        ],
      },
    },
  ],
  "inactive-patient": [
    {
      iconName: "WalletMoney",
      name: "financialManagements",
      items: {
        child: [
          {
            name: "walletBalance",
            path: path.financialRecords.walletBalance.link(),
          },
        ],
      },
    },
  ],
  staff: [
    {
      iconName: "Home",
      name: "dashboard",
      items: { path: "/" },
    },
    {
      iconName: "UsersGroupTwoRounded",
      name: "userManagement.patients",
      items: {
        child: [
          { name: "patientList", path: path.patients.patient.link() },
          { name: "pastVisitSummaryNote", path: path.summaryNote.list.link() },
          {
            name: "pastVisitSummaryNoteManagement",
            path: path.summaryNote.management.link(),
          },
        ],
      },
    },
    {
      iconName: "ClipboardHeart",
      name: "MedicalOrders.title",
      items: {
        child: [
          {
            name: "MedicalOrders.prescription",
            path: path.healthRecord.prescription.link(),
          },
          {
            name: "MedicalOrders.referrals",
            path: path.healthRecord.referral.link(),
          },
          {
            name: "MedicalOrders.followup",
            path: path.healthRecord.followup.link(),
          },
          {
            name: "MedicalOrders.orders",
            path: path.healthRecord.orders.link(),
          },
          {
            name: "MedicalOrders.experiments",
            path: path.healthRecord.experiments.link(),
          },
          {
            name: "MedicalOrders.imaging",
            path: path.healthRecord.images.link(),
          },
        ],
      },
    },
    {
      iconName: "PaperAdd",
      name: "inputFormManagement",
      items: {
        path: path.intakeForm.list.link(),
      },
    },
    {
      iconName: "MonitorCamera",
      name: "AppointmentManagement.myAppointments",
      items: {
        child: [
          {
            name: "AppointmentManagement.onlineVisit",
            path: path.appointment.list.link("online-visit"),
          },
          {
            name: "AppointmentManagement.inPersonVisit",
            path: path.appointment.list.link("in-person-visit"),
          },
        ],
      },
    },
    {
      iconName: "CloseCircle",
      name: "noShowCauses",
      items: {
        path: path.appointment.list.link("no-show"),
      },
    },
    {
      iconName: "UsersGroupTwoRounded",
      name: "myDoctors",
      items: {
        path: path.myDoctors.myDoctors.link(),
      },
    },
    {
      iconName: "DollarMinimalistic",
      name: "financialManagement.title",
      items: {
        child: [
          {
            name: "financialManagement.patientWallet",
            path: path.financial.wallet.link(),
          },
        ],
      },
    },
    {
      iconName: "MonitorCamera",
      name: "reportGeneration.title",
      items: {
        child: [
          {
            name: "userManagement.patients",
            path: path.reports.patients.link(),
          },
          {
            name: "AppointmentManagement.title",
            path: path.reports.appointments.link(),
          },
          {
            name: "pastVisitSummaryNote",
            path: path.reports.visitSummaryNotes.link(),
          },
        ],
      },
    },
  ],
  admin: [
    {
      iconName: "Home",
      name: "dashboard",
      items: { path: "/" },
    },
    {
      iconName: "Hospital",
      name: "healthcareFacility",
      items: { path: path.hf.hfList.link() },
    },
    {
      iconName: "UsersGroupTwoRounded",
      name: "userManagement.users",
      items: {
        child: [
          {
            name: "userManagement.localAdmins",
            path: path.users.localAdmin.link(),
          },
          {
            name: "userManagement.doctors",
            path: path.users.doctor.link(),
          },
          {
            name: "userManagement.staffs",
            path: path.users.staff.link(),
          },
          {
            name: "userManagement.patients",
            path: path.users.patient.link(),
          },
        ],
      },
    },
    {
      iconName: "CheckSquare",
      name: "assignStaffToDoctor",
      items: {
        path: path.assignStaffToDoctor.assignStaffToDoctor.link(),
      },
    },
    {
      iconName: "WalletMoney",
      name: "financialManagement.title",
      items: {
        child: [
          {
            name: "financialManagement.accountingReport",
            path: path.financialReports.financialReports.link(),
          },
          {
            name: "financialManagement.ruleDefinition",
            path: path.financial.list.link(),
          },
          {
            name: "financialManagement.patientWallet",
            path: path.financial.wallet.link(),
          },
        ],
      },
    },
    {
      iconName: "Rate",
      name: "comments",
      items: {
        path: path.comments.comments.link(),
      },
    },
    {
      iconName: "MonitorCamera",
      name: "AppointmentManagement.title",
      items: {
        child: [
          {
            name: "AppointmentManagement.onlineVisit",
            path: path.appointment.list.link("online-visit"),
          },
          {
            name: "AppointmentManagement.inPersonVisit",
            path: path.appointment.list.link("in-person-visit"),
          },
        ],
      },
    },
    {
      iconName: "MonitorCamera",
      name: "reportGeneration.title",
      items: {
        child: [
          {
            name: "userManagement.patients",
            path: path.reports.patients.link(),
          },
          {
            name: "AppointmentManagement.title",
            path: path.reports.appointments.link(),
          },
          {
            name: "doctorFinancialManagements",
            path: path.reports.doctorFinancial.link(),
          },
          {
            name: "hfFinancialManagements",
            path: path.reports.hfFinancial.link(),
          },
          {
            name: "pastVisitSummaryNote",
            path: path.reports.visitSummaryNotes.link(),
          },
        ],
      },
    },
  ],
  "medical-service-provider-drug": [
    {
      iconName: "Home",
      name: "dashboard",
      items: { path: "/" },
    },
    {
      iconName: "Pills",
      name: "prescriptionsList",
      items: { path: path.msp.prescriptionList.link() },
    },
    {
      iconName: "UsersGroupTwoRounded",
      name: "myDoctors",
      items: { path: path.msp.mspDoctors.link() },
    },
    {
      iconName: "Clipboard",
      name: "prescriptionReports",
      items: { path: path.msp.mspReports.link() },
    },
  ],
  "medical-service-provider-lab": [
    {
      iconName: "Home",
      name: "dashboard",
      items: { path: "/" },
    },
    {
      iconName: "Pills",
      name: "experimentsList",
      items: { path: path.msp.experimentList.link() },
    },
    {
      iconName: "UsersGroupTwoRounded",
      name: "myDoctors",
      items: { path: path.msp.mspDoctors.link() },
    },
    {
      iconName: "Clipboard",
      name: "prescriptionReports",
      items: { path: path.msp.mspReports.link() },
    },
  ],
  "medical-service-provider-image": [
    {
      iconName: "Home",
      name: "dashboard",
      items: { path: "/" },
    },
    {
      iconName: "Pills",
      name: "imagesList",
      items: { path: path.msp.imagesList.link() },
    },
    {
      iconName: "UsersGroupTwoRounded",
      name: "myDoctors",
      items: { path: path.msp.mspDoctors.link() },
    },
    {
      iconName: "Clipboard",
      name: "prescriptionReports",
      items: { path: path.msp.mspReports.link() },
    },
  ],
};

export const footerSidebarItems: { [key in IRole]: IFooterSidebarItem[] } = {
  "super-admin": [
    { iconName: "Home", name: "dashboard", items: { path: "/" } },
    {
      iconName: "UsersGroupRounded",
      name: "userManagement.shortUsers",
      items: { path: path.users.users.link() },
    },
    {
      iconName: "DollarMinimalistic",
      name: "financialManagement.shortTitle",
      items: { path: path.financial.list.link() },
    },
  ],
  "local-admin": [
    { iconName: "Home", name: "dashboard", items: { path: "/" } },
    {
      iconName: "UsersGroupRounded",
      name: "userManagement.shortStaffs",
      items: { path: path.users.staff.link() },
    },
    {
      iconName: "UsersGroupRounded",
      name: "userManagement.shortPatients",
      items: { path: path.users.patient.link() },
    },
  ],
  doctor: [
    { iconName: "Home", name: "dashboard", items: { path: "/" } },
    {
      iconName: "CalendarAdd",
      name: "calendar",
      items: { path: path.availabilityTime.availabilityTime.link() },
    },
    {
      iconName: "MonitorCamera",
      name: "AppointmentManagement.shortTitle",
      items: { path: path.appointment.list.link("online-visit") },
    },
  ],
  staff: [
    { iconName: "Home", name: "dashboard", items: { path: "/" } },
    {
      iconName: "UsersGroupRounded",
      name: "userManagement.shortPatients",
      items: { path: path.patients.patient.link() },
    },
    {
      iconName: "MonitorCamera",
      name: "AppointmentManagement.shortTitle",
      items: { path: path.appointment.list.link("online-visit") },
    },
  ],
  admin: [
    { iconName: "Home", name: "dashboard", items: { path: "/" } },
    {
      iconName: "MonitorCamera",
      name: "AppointmentManagement.shortTitle",
      items: { path: path.appointment.list.link("online-visit") },
    },
    {
      iconName: "UsersGroupTwoRounded",
      name: "userManagement.shortDoctors",
      items: { path: path.users.doctor.link() },
    },
  ],
  patient: [
    { iconName: "Home", name: "dashboard", items: { path: "/" } },
    {
      iconName: "MonitorCamera",
      name: "AppointmentManagement.shortTitle",
      items: { path: path.appointment.list.link("online-visit") },
    },
    {
      iconName: "PaperMedicine",
      name: "shortHealthRecord",
      items: { path: path.healthRecord.experiments.link() },
    },
  ],
  "inactive-patient": [
    { iconName: "Home", name: "dashboard", items: { path: "/" } },

    {
      iconName: "WalletMoney",
      name: "walletBalance",
      items: { path: path.financialRecords.walletBalance.link() },
    },
  ],
  "medical-service-provider-drug": [
    {
      iconName: "Home",
      name: "dashboard",
      items: { path: "/" },
    },
    {
      iconName: "Pills",
      name: "prescriptionsList",
      items: { path: path.msp.prescriptionList.link() },
    },
    {
      iconName: "UsersGroupTwoRounded",
      name: "myDoctors",
      items: { path: path.msp.mspDoctors.link() },
    },
    {
      iconName: "Clipboard",
      name: "prescriptionReports",
      items: { path: path.msp.mspReports.link() },
    },
  ],
  "medical-service-provider-lab": [
    {
      iconName: "Home",
      name: "dashboard",
      items: { path: "/" },
    },
    {
      iconName: "Pills",
      name: "experimentsList",
      items: { path: path.msp.experimentList.link() },
    },
    {
      iconName: "UsersGroupTwoRounded",
      name: "myDoctors",
      items: { path: path.msp.mspDoctors.link() },
    },
    {
      iconName: "Clipboard",
      name: "prescriptionReports",
      items: { path: path.msp.mspReports.link() },
    },
  ],
  "medical-service-provider-image": [
    {
      iconName: "Home",
      name: "dashboard",
      items: { path: "/" },
    },
    {
      iconName: "Pills",
      name: "imagesList",
      items: { path: path.msp.imagesList.link() },
    },
    {
      iconName: "UsersGroupTwoRounded",
      name: "myDoctors",
      items: { path: path.msp.mspDoctors.link() },
    },
    {
      iconName: "Clipboard",
      name: "prescriptionReports",
      items: { path: path.msp.mspReports.link() },
    },
  ],
};
